<template>
  <div :class="$style.wrapper">
    <ul :class="$style.container">
      <li @click="click(1)">
        <SvgIcon :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/arrow-left.svg')" :size="18" />
      </li>
      <li v-for="p in pageRange" @click="click(p)" :class="{
        [$style.page_current]: p == page,
      }">
        {{ p }}
      </li>
      <li @click="click(lastPage)">
        <SvgIcon :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/arrow-right.svg')" :size="18" />
      </li>
    </ul>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'

export default {
  components: {
    SvgIcon,
  },
  props: {
    page: {
      type: Number,
    },
    size: {
      type: Number,
    },
    total: {
      type: Number,
    },
  },
  computed: {
    lastPage () {
      return Math.ceil(1.0 * this.total / this.size)
    },
    pageRange () {
      const r = []
      const start = Math.max(1, this.page - 1)
      const end = Math.min(this.lastPage, this.page + 1)
      for (let i = start; i <= end; i++) {
        r.push(i)
      }
      return r
    },
  },
  methods: {
    click (page) {
      this.$emit('change', page)
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  @apply text-center;
  @apply p-4;
}

.container {
  @apply list-none;
  @apply m-0;
  @apply p-0;
  @apply inline-flex;
  @apply items-center;

  > li {
    @apply inline-block;
    @apply leading-none;
    @apply p-1;
    min-width: 20px;
    @apply text-center;
    @apply text-orange-400;

    &:hover {
      @apply cursor-pointer;
    }
  }
}

li.page_current {
  color: black;
}
</style>
